export default __webpack_public_path__ + "static/media/background-workshopBackdrop.95ea4c73.svg";